import { render } from "./NavLink.vue?vue&type=template&id=d2241526&ts=true"
import script from "./NavLink.vue?vue&type=script&lang=ts"
export * from "./NavLink.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__